import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getIncidentComments(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENT_COMMENTS,
		ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].GET_INCIDENT_COMMENTS,
		options
	)
}

function _createIncidentComment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENT_COMMENTS,
		ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].CREATE_INCIDENT_COMMENT,
		options
	)
}

function _getIncidentComment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENT_COMMENTS,
		ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].GET_INCIDENT_COMMENT,
		options
	)
}

function _patchIncidentComment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENT_COMMENTS,
		ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].PATCH_INCIDENT_COMMENT,
		options
	)
}

function _putIncidentComment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENT_COMMENTS,
		ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].PUT_INCIDENT_COMMENT,
		options
	)
}

function _deleteIncidentComment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENT_COMMENTS,
		ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].DELETE_INCIDENT_COMMENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].GET_INCIDENT_COMMENTS]: _getIncidentComments,
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].CREATE_INCIDENT_COMMENT]:
		_createIncidentComment,
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].GET_INCIDENT_COMMENT]: _getIncidentComment,
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].PATCH_INCIDENT_COMMENT]: _patchIncidentComment,
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].PUT_INCIDENT_COMMENT]: _putIncidentComment,
	[ModulesConfigMap[ModulesMap.INCIDENT_COMMENTS].DELETE_INCIDENT_COMMENT]:
		_deleteIncidentComment,
}
